export default function getHeaderTitle(pathname) {
    let paths = pathname.split('/')
    paths.shift()
    if(paths.includes('campus')){
        return paths[3]
    }else{
        return
    }
}